"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var p_defer_1 = __importDefault(require("p-defer"));
var uuid_1 = require("uuid");
var BringgException_1 = require("../../Core/BringgException");
var ExceptionReason_1 = require("../../Core/ExceptionReason");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var entityName = 'application_action';
var ApplicationEntity = /** @class */ (function (_super) {
    __extends(ApplicationEntity, _super);
    function ApplicationEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: entityName
        }) || this;
        _this.inFlightActions = new Map();
        _this.realTime.on('application action process done', _this.handleApplicationActionResult.bind(_this));
        return _this;
    }
    ApplicationEntity.prototype.generateActionUuid = function () {
        return (0, uuid_1.v4)();
    };
    ApplicationEntity.prototype.executeAction = function (actionName, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var actionUuid, deferred;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionUuid = this.generateActionUuid();
                        lodash_1.default.defaults(options, { timeout: 10000 });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 4, 5]);
                        deferred = (0, p_defer_1.default)();
                        this.inFlightActions.set(actionUuid, deferred);
                        return [4 /*yield*/, this.createApplicationAction({
                                action_name: actionName,
                                data: __assign(__assign({}, data), { deadline: Date.now() + options.timeout }),
                                uuid: actionUuid
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.race([deferred.promise, this.asyncTimeout(options.timeout)])];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        this.inFlightActions.delete(actionUuid);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationEntity.prototype.createApplicationAction = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post("/".concat(entityName, "/create"))
                            .withExtractor(function (res) { return res.uuid; })
                            .setException('could not execute action')
                            .withPayload(data)
                            .invoke()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ApplicationEntity.prototype.handleApplicationActionResult = function (result) {
        var defered = this.inFlightActions.get(result.response_uuid);
        if (lodash_1.default.isNil(defered)) {
            return;
        }
        if (result.success) {
            defered.resolve(result.data);
        }
        else {
            var isStringError = result.error != null && typeof result.error.valueOf() === 'string';
            var data = isStringError ? { error_message: result.error } : result.error;
            defered.reject(new BringgException_1.BringgException(ExceptionReason_1.ExceptionReason.UNSUCCESSFUL_RESULT, isStringError ? result.error : 'Unsuccessful application action result', null, __assign(__assign({}, data), { response_uuid: result.response_uuid })));
        }
    };
    ApplicationEntity.prototype.asyncTimeout = function (milliseconds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, milliseconds); })];
                    case 1:
                        _a.sent();
                        throw new Error('timeout');
                }
            });
        });
    };
    return ApplicationEntity;
}(StoreEntity_1.default));
exports.default = ApplicationEntity;
//# sourceMappingURL=ApplicationEntity.js.map